{
  "otherOrganizations": "その他の組織",
  "solutionIframe": "メインコンテンツ",
  "unloadPromptMessage": "よろしいですか？"
}
